import React, { ReactNode } from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

type GradientBackgroundProps = {
  children: ReactNode;
  style?: ViewStyle | ViewStyle[];
  colors?: readonly [string, string, ...string[]]; 
  start?: { x: number; y: number };
  end?: { x: number; y: number };
};

export default function LocationBarGradientBackground({
  children,
}: GradientBackgroundProps) {
  return (
    <View style={{ width: "100%" }}>
      <LinearGradient
        colors={["#C9EEF4", "#FFDFD4", "#FFEF97"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }}
        style={StyleSheet.absoluteFill}
      />

      {/* Vertical white fade overlay */}
      <LinearGradient
        colors={["rgba(255,255,255,0)", "rgba(255,255,255,0.9)"]}
        start={{ x: 1, y: 0 }}
        end={{ x: 0, y: 0 }}
        style={StyleSheet.absoluteFill}
      />
        {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: 24,  
    overflow: "hidden",  
  },
});